"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisconnectionReason = void 0;
/**
 * The disconnection reason.
 */
var DisconnectionReason;
(function (DisconnectionReason) {
    /**
     * When the reconnection is failed.
     */
    DisconnectionReason["RECONNECTION_FAILED"] = "reconnection_failed";
    /**
     * When the `disconnect` or `forceDisconnect` method is called.
     */
    DisconnectionReason["EXPLICIT"] = "explicit";
    /**
     * When backend sends logout message.
     */
    DisconnectionReason["LOG_OUT"] = "log_out";
    /**
     * When the browser about to close.
     */
    DisconnectionReason["WINDOW_BEFORE_UNLOAD"] = "window_before_unload";
})(DisconnectionReason = exports.DisconnectionReason || (exports.DisconnectionReason = {}));
//# sourceMappingURL=disconnection_reason.js.map